import React, { useCallback } from 'react';
import { IBoxComponent, IBoxSubmitComponent } from '@enuan/chat__utils';
import { Button, IButtonProps } from '../../UI/Button/Button';
import { cleanBoxProps } from '../../../utils/cleanBoxProps';

type ISubmitProps = Omit<
	IBoxComponent<IBoxSubmitComponent<IButtonProps>>,
	'onChange'
> & { onChange?: (value: boolean) => void; value?: boolean };

export const Submit = ({
	type, //removes
	remember_label, //removes
	label = 'Submit',
	disabled,
	onAction,
	onChange,
	onClick,
	id, //ignore it to avoid duplicate
	children,
	remember,
	value,
	..._props
}: ISubmitProps) => {
	const props = cleanBoxProps(_props);

	const _onClick = useCallback<React.MouseEventHandler<HTMLButtonElement>>(
		(e) => {
			onClick?.(e);
			onAction?.();
		},
		[onClick, onAction],
	);

	return (
		<Button disabled={disabled} onClick={_onClick} type="submit" {...props}>
			{label ?? children}
		</Button>
	);
};
